import { createAction } from '@reduxjs/toolkit';

export const ACTION_ADD_PHOTO_COMMIT = 'photosFromDevice/addPhoto/commit';

export const deletePhoto = createAction(
  'photosFromDevice/deletePhoto',
  function prepare(clientId, applicationId, photoId) {
    return {
      payload: {
        clientId,
        applicationId,
        photoId,
      },
      meta: {
        offline: {
          effect: {
            url: `/qac/photo-gallery/${photoId}`,
            method: 'DELETE',
          },
          commit: {
            type: 'photosFromDevice/deletePhoto/commit',
            meta: {
              clientId,
              photoId,
              applicationId,
              // after: applicationId ? undefined : fetchClientDataById,
              // afterArgs: [{ clientId }],
            },
          },
          rollback: {
            type: 'photosFromDevice/deletePhoto/rollback',
            meta: { clientId, photoId },
          },
        },
      },
    };
  }
);

export const addPhoto = createAction(
  'photosFromDevice/addPhoto',
  function prepare(clientId, reportId, photo, source, onUploadProgress) {
    const payload = {
      clientId,
      reportId,
      photo,
    };

    const { link: _, ...photoWithoutContent } = photo;
    let isStarted = false;

    return {
      payload,
      meta: {
        offline: {
          effect: {
            url: `/qac/photo-gallery/${photo.id}`,
            method: 'POST',
            data: {
              clientId,
              fileName: photo.fileName,
              description: photo.description,
              tags: photo.tags,
              imageBinary: photo.link,
            },
            onUploadProgress: (event) => {
              !isStarted &&
                onUploadProgress &&
                onUploadProgress(event, payload);
              isStarted = true;
            },
            cancelToken: source?.token,
          },
          commit: {
            type: ACTION_ADD_PHOTO_COMMIT,
            meta: {
              clientId,
              reportId,
              photo: photoWithoutContent,
              // after: applicationId ? undefined : fetchClientDataById,
              // afterArgs: [{ clientId }],
            },
          },
          rollback: {
            type: 'photosFromDevice/addPhoto/rollback',
            meta: { clientId, reportId, photo },
          },
        },
      },
    };
  }
);

export const editPhoto = createAction(
  'photosFromDevice/editPhoto',
  function prepare(clientId, applicationId, photoId, photo) {
    return {
      payload: {
        clientId,
        applicationId,
        photoId,
        photo,
      },
      meta: {
        offline: {
          effect: {
            url: `/qac/photo-gallery/${photoId}`,
            method: 'PUT',
            data: {
              clientId,
              description: photo.description,
              tags: photo.tags,
            },
          },
          commit: {
            type: 'photosFromDevice/editPhoto/commit',
            meta: {
              clientId,
              applicationId,
              photo,
              // after: applicationId
              //   ? [fetchCurrentlyLoggedUser]
              //   : [fetchClientDataById, fetchCurrentlyLoggedUser],
              // afterArgs: [[{ clientId }], []],
            },
          },
          rollback: {
            type: 'photosFromDevice/editPhoto/rollback',
            meta: { clientId, photo },
          },
        },
      },
    };
  }
);

export const setLoading = createAction(
  'photosFromDevice/setLoading',
  function prepare(loading) {
    return {
      payload: {
        loading,
      },
    };
  }
);
